var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountCreateSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 470,
    viewBox: "0 0 470 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.76 201.146C209.144 208.61 188.396 236.332 188.396 236.332L163.117 206.473C151.908 210.026 142.392 217.568 136.373 227.669L170.359 266.187C174.052 270.364 179.113 273.088 184.634 273.87C190.154 274.651 195.773 273.44 200.48 270.452L243.27 243.219L221.146 264.277L213.771 363.615C225.108 367.911 237.655 367.737 248.868 363.126L258.598 211.276C250.994 215.807 231.624 209.279 223.76 201.146Z",
    fill: "#60B8CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.372 182.799C248.545 182.799 246.794 183.524 245.503 184.816C244.211 186.107 243.486 187.859 243.486 189.685C243.486 191.511 244.211 193.263 245.503 194.554C246.794 195.846 248.545 196.571 250.372 196.571C252.198 196.571 253.95 195.846 255.241 194.554C256.532 193.263 257.258 191.511 257.258 189.685C257.258 187.859 256.532 186.107 255.241 184.816C253.95 183.524 252.198 182.799 250.372 182.799Z",
    fill: "#60B8CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M305.905 338.559C305.902 344.235 307.887 349.733 311.514 354.099C315.142 358.465 320.183 361.423 325.764 362.46V415.639H334.694V362.46C340.272 361.418 345.311 358.459 348.937 354.094C352.564 349.729 354.55 344.233 354.552 338.559H305.905ZM330.206 355.53C329.606 355.529 329.011 355.411 328.455 355.181C327.9 354.951 327.396 354.614 326.971 354.189C326.546 353.763 326.209 353.259 325.98 352.704C325.75 352.148 325.632 351.553 325.632 350.952C325.632 350.352 325.75 349.757 325.98 349.201C326.211 348.646 326.548 348.142 326.973 347.717C327.398 347.292 327.902 346.955 328.458 346.726C329.013 346.496 329.608 346.378 330.209 346.378C331.422 346.378 332.586 346.86 333.444 347.719C334.302 348.577 334.784 349.741 334.784 350.955C334.783 352.168 334.301 353.332 333.443 354.19C332.584 355.048 331.42 355.53 330.206 355.53Z",
    fill: "#60B8CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.546 415.513C146.772 412.712 147.688 410.011 149.212 407.65C155.249 398.631 159.874 391.048 159.874 369.221H128.82C128.82 389.563 132.709 396.812 139.26 407.25C140.922 409.712 141.931 412.555 142.193 415.513C142.015 422.666 141.257 425.198 134.151 427.686H154.588C147.524 425.191 146.635 422.659 146.546 415.513ZM138.816 392.456L140.771 385.97L135.351 381.882L142.148 381.749L144.369 375.352L146.591 381.749L153.388 381.882L147.968 385.97L149.923 392.456L144.369 388.591L138.816 392.456Z",
    fill: "#60B8CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243.219 243.219L221.094 264.277L221.628 256.947L243.219 243.219Z",
    fill: "#0C758C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.756 400.711C243.058 388.995 242.365 376.905 243.708 364.957C236.069 367.068 228.025 367.249 220.3 365.481C220.827 371.048 220.176 376.664 218.389 381.963C221.499 385.545 227.812 387.206 229.096 400.756C229.284 402.645 230.164 404.397 231.566 405.677C232.969 406.956 234.795 407.672 236.693 407.686H260.461C258.642 405.551 256.391 403.825 253.856 402.623C251.321 401.421 248.561 400.769 245.756 400.711Z",
    fill: "#0C758C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.276 190.307C126.905 187.42 100.027 186.131 89.8977 190.307C99.5227 197.117 109.9 202.797 120.823 207.234C124.964 208.356 128.755 210.507 131.841 213.489L139.971 222.641C144.951 216.113 151.574 211.023 159.164 207.891L144.276 190.307Z",
    fill: "#0C758C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M244.863 144.857L248.239 148.723C248.354 147.836 248.588 146.971 248.941 146.15C247.543 145.851 246.178 145.418 244.863 144.857Z",
    fill: "#0C758C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.259 117.891C219.184 130.686 238.243 141.837 239.677 142.639C239.628 139.019 239.286 135.408 238.655 131.843C233.768 130.207 236.034 124.424 239.321 126.699C240.36 127.527 241.442 128.018 241.632 126.699C243.009 118.347 249.362 116.126 253.36 123.856C247.928 112.871 240.673 108.926 231.259 117.891Z",
    fill: "#0C758C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.29 102.474C230.879 101.306 229.156 100.576 227.335 100.374C225.514 100.172 223.674 100.507 222.04 101.337C220.407 102.168 219.053 103.458 218.143 105.049C217.234 106.639 216.809 108.461 216.922 110.29C217.035 112.119 217.68 113.875 218.778 115.342C219.876 116.808 221.379 117.922 223.102 118.546C224.825 119.169 226.693 119.276 228.475 118.851C230.258 118.427 231.877 117.491 233.134 116.158C234.773 114.203 235.599 111.693 235.442 109.148C235.285 106.602 234.156 104.213 232.29 102.474Z",
    fill: "#0C758C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.95 167.338C193.55 171.336 194.35 174.586 196.304 175.246C198.615 176.001 201.236 173.957 203.635 170.714C200.371 169.693 197.141 168.567 193.95 167.338Z",
    fill: "#0C758C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M223.36 184.042L220.65 187.818C220.072 186.099 219.448 184.395 218.78 182.709C220.384 183.153 221.939 183.598 223.36 184.042Z",
    fill: "#0C758C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.348 21.6628V75.6413C289.023 88.614 324.698 62.6687 360.372 75.6413V21.6628C324.698 8.69023 289.014 34.6355 253.348 21.6628Z",
    fill: "#0C758C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M360.372 120.869V156.411",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M360.372 12.8672V95.4121",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.28 151.746L250.372 182.8L229.136 152.501",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.76 201.148C209.144 208.612 188.396 236.334 188.396 236.334L163.117 206.475C151.908 210.028 142.392 217.57 136.373 227.671L170.277 266.189C173.971 270.363 179.031 273.085 184.55 273.867C190.069 274.648 195.686 273.439 200.394 270.454L221.63 256.948L213.722 363.617C225.084 367.877 237.636 367.686 248.863 363.084L258.593 211.278",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M243.219 243.221L221.094 264.279L221.628 256.949L243.219 243.221Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.344 412.374C262.656 410.662 261.68 409.08 260.457 407.698H236.733C234.837 407.676 233.015 406.957 231.614 405.679C230.213 404.401 229.331 402.653 229.136 400.767C228.835 395.865 227.122 391.155 224.204 387.205C223.136 385.919 219.939 383.651 218.429 381.963C216.252 389.56 218.017 389.081 220.384 391.914C223.313 395.837 225.028 400.533 225.315 405.42C225.486 407.31 226.354 409.069 227.75 410.354C229.146 411.639 230.97 412.358 232.868 412.372L263.344 412.374Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M243.703 364.959C242.368 376.893 243.06 388.966 245.751 400.669C248.548 400.722 251.302 401.37 253.83 402.569C256.357 403.768 258.601 405.49 260.412 407.623H236.688C234.791 407.616 232.964 406.906 231.561 405.629C230.157 404.353 229.277 402.601 229.091 400.713C228.818 395.806 227.102 391.088 224.16 387.151C223.063 385.849 219.851 383.597 218.385 381.909C218.607 381.154 218.829 380.354 219.14 379.421C220.304 374.887 220.699 370.19 220.309 365.525",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M159.164 207.9L144.276 190.307C126.905 187.42 100.027 186.131 89.8977 190.307C99.5266 197.111 109.903 202.79 120.823 207.234C124.967 208.354 128.757 210.507 131.841 213.489L139.971 222.641",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9022 190.309C87.9635 188.945 86.067 187.523 84.2156 186.044C94.0362 181.334 122.6 182.267 140.238 185.51L144.276 190.309",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M248.239 148.72L244.821 144.859C246.158 145.409 247.54 145.841 248.952 146.148",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.024 125.571C119.935 125.704 116.049 122.828 111.36 119.258C106.109 115.283 106.604 112.73 113.448 116.37C116.825 118.379 120.522 119.792 124.377 120.546",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M127.087 116.96C127.087 116.96 115.396 108.652 114.648 108.074C109.183 103.898 107.551 105.755 111.716 110.429C115.546 114.729 120.734 119.67 120.734 119.67",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M207.367 146.991C178.578 136.817 147.655 122.205 147.435 122.112C145.057 121.099 142.637 118.069 143.081 115.798C143.839 111.933 145.527 106.415 143.57 106.024C140.595 105.433 138.816 113.755 136.017 115.665C135.04 116.331 132.243 114.285 131.264 113.355C129.627 111.795 124.069 106.555 123.533 106.024C118.623 101.159 116.986 103.324 120.557 107.979C122.415 110.312 123.968 112.872 125.179 115.597",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.175 114.738C125.469 118.125 123.065 122.702 122.378 127.676",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M131.353 118.557C129.842 124.11 130.819 128.686 135.529 131.529",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M269.253 172.76C269.599 175.337 269.688 177.941 269.519 180.534",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M239.62 142.681C228.38 136.368 222.266 126.477 233.134 116.114C242.641 107.984 249.794 116.514 253.348 123.844",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M232.29 102.476C230.879 101.308 229.156 100.578 227.335 100.376C225.514 100.174 223.674 100.509 222.04 101.339C220.407 102.17 219.053 103.46 218.143 105.051C217.234 106.641 216.809 108.463 216.922 110.292C217.035 112.121 217.68 113.877 218.778 115.344C219.876 116.81 221.379 117.924 223.102 118.548C224.825 119.171 226.693 119.277 228.475 118.853C230.258 118.429 231.877 117.493 233.134 116.16C234.773 114.205 235.599 111.695 235.442 109.149C235.285 106.604 234.156 104.215 232.29 102.476Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M196.393 175.292C194.434 174.623 193.548 171.317 193.952 167.316",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M203.635 170.716C179.275 162.948 138.987 142.874 123.756 134.019C120.554 132.148 117.304 130.39 114.071 128.599C112.751 127.873 111.447 127.117 110.161 126.333C104.682 122.98 104.963 120.869 111.849 123.49C114.45 124.463 117.145 125.163 119.89 125.578H119.935C120.847 125.732 121.766 125.821 122.689 125.845",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M357.174 113.76C352.778 113.386 352.687 108.066 356.952 108.118C360.106 108.157 362.372 108.295 364.859 108.429C369.08 108.662 368.991 114.274 365.526 114.382C362.733 114.314 359.946 114.106 357.174 113.76Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M360.461 95.9453C362.016 95.9008 363.127 95.9242 364.637 95.9008C368.636 95.8424 368.769 101.513 365.481 101.81C363.779 101.924 362.075 101.924 360.372 101.81",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M356.107 119.803C351.887 119.319 351.887 114.161 356.018 114.338C359.084 114.472 361.258 114.668 363.66 114.872C367.7 115.213 367.525 120.647 364.193 120.647C362.149 120.647 360.017 120.252 356.107 119.803Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M360.33 101.955C361.967 102 363.351 102.13 364.951 102.177C369.216 102.303 369.305 107.997 365.75 108.219C363.618 108.353 361.352 108.035 357.265 107.819C356.807 107.827 356.355 107.723 355.945 107.518C355.536 107.313 355.182 107.013 354.914 106.642C354.646 106.271 354.471 105.841 354.404 105.388C354.338 104.935 354.381 104.473 354.531 104.041C354.735 103.461 355.118 102.965 355.628 102.621",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M278.183 139.883C311.059 122.779 349.888 92.4682 355.13 92.8353C361.305 93.2679 360.756 93.5368 360.195 104.12C360.057 106.692 355.574 106.963 354.775 98.7417C355.441 105.055 352.553 109.36 348.288 110.737",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M363.393 120.602C357.796 121.135 350.687 121.046 341.402 127.85C325.563 139.475 309.052 150.156 291.955 159.837",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M218.866 182.74C220.466 183.229 221.946 183.598 223.412 183.998L220.695 187.767",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M218.866 182.741C221.169 188.694 222.815 194.881 223.776 201.192C231.64 209.322 251.01 215.808 258.616 211.277C263.148 196.312 268.834 191.24 269.545 180.533C278.075 176.224 287.36 171.115 292.736 166.228C292.736 156.365 286.738 144.716 278.209 139.883C271.116 144.211 263.806 148.17 256.306 151.745C253.641 152.902 252.485 153.255 251.162 152.767C246.675 155.032 240.322 154.455 234.635 152.633C233.758 152.905 232.835 152.982 231.925 152.855C223.575 151.726 215.359 149.761 207.402 146.991C214.821 149.919 204.46 177.299 196.428 175.284C203.818 178.031 211.302 180.518 218.866 182.741Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M251.134 152.766C250.309 152.451 249.594 151.899 249.081 151.18C248.567 150.461 248.277 149.607 248.246 148.724C248.363 147.84 248.599 146.975 248.948 146.151C258.287 147.606 257.452 133.485 253.346 123.849C249.348 116.119 242.903 118.326 241.617 126.693C241.414 128.016 240.214 127.495 239.263 126.737C235.975 124.471 233.709 130.244 238.596 131.881C239.235 135.445 239.576 139.057 239.618 142.677C239.595 147.208 238.863 151.328 234.598 152.628",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.084 457.135V412.441H282.359V457.135",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M101.809 457.134V434.787H192.084V457.134",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M282.359 457.136V424.26H372.678V457.136",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M253.348 21.6628V75.6413C289.023 88.614 324.698 62.6687 360.372 75.6413V21.6628C324.698 8.69023 289.013 34.6355 253.348 21.6628Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M347.4 415.641V424.259H312.969V415.641H347.4Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M305.905 338.561C305.917 344.233 307.907 349.723 311.532 354.086C315.157 358.449 320.19 361.411 325.764 362.462V415.641H334.694V362.462C340.276 361.428 345.319 358.471 348.947 354.104C352.575 349.738 354.559 344.238 354.552 338.561H305.905Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M312.613 355.308C308.058 355.487 303.54 354.419 299.548 352.219C295.555 350.019 292.238 346.77 289.956 342.824H306.317",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M347.977 355.308C352.533 355.487 357.05 354.419 361.043 352.219C365.036 350.019 368.352 346.77 370.635 342.824H354.33",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M328.429 225.538C328.431 227.085 327.973 228.598 327.114 229.884C326.255 231.17 325.033 232.172 323.603 232.763C322.054 233.406 320.339 233.532 318.711 233.125C317.084 232.717 315.631 231.797 314.567 230.501C313.502 229.204 312.883 227.6 312.801 225.925C312.718 224.249 313.177 222.592 314.108 221.197C315.04 219.802 316.396 218.744 317.975 218.178C319.554 217.613 321.274 217.57 322.879 218.057C324.484 218.544 325.89 219.534 326.89 220.881C327.889 222.228 328.429 223.861 328.429 225.538Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M334.808 350.96C334.808 351.637 334.657 352.306 334.367 352.918C334.078 353.53 333.656 354.07 333.132 354.499C332.609 354.929 331.997 355.237 331.34 355.402C330.684 355.567 329.998 355.584 329.334 355.452C328.447 355.274 327.632 354.837 326.992 354.197C326.352 353.556 325.916 352.741 325.738 351.854C325.56 350.966 325.65 350.045 325.996 349.208C326.343 348.371 326.93 347.656 327.684 347.154C328.564 346.564 329.622 346.299 330.676 346.403C331.73 346.507 332.716 346.974 333.464 347.724C334.322 348.582 334.806 349.747 334.808 350.96Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M180.687 68.668V84.6172",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M188.663 76.6426H172.669",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M144.858 303.373L139.349 315.656H149.39L143.881 327.941",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M154.33 210.216L181.244 241.976C186.042 247.841 189.818 247.618 194.083 242.021C202.033 231.58 216.563 213.321 228.689 205.146",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M150.678 212.476L180.399 246.729C181.365 247.849 182.572 248.737 183.928 249.326C185.285 249.915 186.757 250.19 188.235 250.131C189.713 250.071 191.158 249.677 192.463 248.98C193.768 248.284 194.898 247.302 195.771 246.107C204.383 234.329 219.273 215.453 231.846 207.012",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M233.134 249.84L224.782 366.282",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M155.654 434.61H133.085L134.151 427.68H154.588L155.654 434.61Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M135.218 400.802C129.398 400.802 116.025 393.584 116.025 374.48H128.953",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M147.968 385.963L149.923 392.449L144.369 388.584L138.816 392.449L140.771 385.963L135.351 381.876L142.148 381.698L144.369 375.301L146.591 381.698L153.388 381.876L147.968 385.963Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M154.588 427.673C147.524 425.185 146.591 422.652 146.546 415.5C146.767 412.698 147.683 409.995 149.212 407.636C155.546 398.077 159.874 390.52 159.874 369.207H128.865C128.865 389.55 132.753 396.798 139.305 407.236C140.971 409.696 141.98 412.54 142.237 415.5C142.087 422.652 141.302 425.185 134.196 427.673H154.588Z",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M153.699 400.802C159.563 400.802 172.669 393.554 172.669 374.457H159.785",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M407.554 457.135H62.4465",
    stroke: "#0B404B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M250.372 182.799C248.545 182.799 246.794 183.524 245.503 184.816C244.211 186.107 243.486 187.859 243.486 189.685C243.486 191.511 244.211 193.263 245.503 194.554C246.794 195.846 248.545 196.571 250.372 196.571C252.198 196.571 253.95 195.846 255.241 194.554C256.532 193.263 257.258 191.511 257.258 189.685C257.258 187.859 256.532 186.107 255.241 184.816C253.95 183.524 252.198 182.799 250.372 182.799Z",
    stroke: "#0B404B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCreateSuccess);
export default __webpack_public_path__ + "static/media/account-create-success.3ddeddcc2d1413998805f68465087cab.svg";
export { ForwardRef as ReactComponent };